import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { CaseService } from '../../../shared/services/case.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { FormControl, FormGroup } from '@angular/forms';
import { UserService } from '../../../shared/services/user.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { PreSignService } from '../../../shared/services/preSign.service';
import { environment } from '../../../../../environments/environment';
import { NotifyPopupComponent } from '../notify-popup/notify-popup.component';

@Component({
  selector: 'downloadUpload',
  templateUrl: './downloadUpload.component.html',
  styleUrls: ['./downloadUpload.component.css'],
  providers: [
    LocalUserService,
    PreSignService
  ]
})
export class DownloadUploadComponent implements OnInit {
  // these come from outside
  case: string;
  org: string;
  temp: string;
  form: string;


  // this is for ui
  uiInfo = {
    formName: '',
    action: ''
  };

  // component variables
  caseData: any = null;

  caseStatus: string;
  token: string;
  userID: string;
  formId: string;
  userRole: string;
  loading: boolean;
  loadingTwo: boolean;
  error: string;
  isError = false;

  fileName = '2.3.pdf';

  downloadFormLoader: boolean = false;
  downloadPDFLink = null;
  caseIsBond: boolean;

  reports: boolean = false;

  upload1: boolean = false;
  upload2: boolean = false;

  formName: string = "PETITION FOR LIMITED GUARDIANSHIP";
  constructor(
    public thisDialog: MatDialogRef<DownloadUploadComponent>,
    public dialog: MatDialog,
    private caseService: CaseService,
    private cognito: CognitoUtil,
    private userService: UserService,
    private localUser: LocalUserService,
    private preSign: PreSignService,
    public snackBar: MatSnackBar,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.case !== null) {
      this.case = this.data.case;
      this.temp = this.data.temp;
    }
    else {
      this.case = this.data.temp;
      this.temp = this.case;
    }
    
    this.form = this.data.form;
    if (this.data.form_Id) {
      this.formId = this.data.form_Id
    }

    if (this.formId === 'PC2.6-GuardianAppointment') {
      this.formName = "PC2.6 Appointment of guardian ad-litem";
      this.form = "PC2.6-appointment-of-guardian-ad-litem";
      this.fileName = "PC2.6-appointment-of-guardian-ad-litem.pdf";
    } else if (this.formId === 'PC3.1a-bond') {
      this.formName = "PC3.1 UNIVERSAL APPOINTMENT BOND";
      this.form = "PC3.1a-bond";
      this.fileName = "PC3.1a-bond.pdf";
    } else if (this.formId === "PC3.3-Inventory") {
      this.formName = "PC3.3 Universal-inventory";
      this.form = "PC3.3-Inventory";
      this.fileName = "PC3.3-Inventory.pdf";
    } else if (this.formId === "2.3_judge-signed") {
      this.formName = "2.3 Judge Signed";
      this.form = "2.3_judge";
      this.fileName = "2.3_signed.pdf";
    } else if (this.formId === "Reports_upload") {
      this.formName = "Guardian Ad Litem Report and Fees";
      this.form = "GardianAdlitem_Reports";
      this.fileName = "reports.pdf";
      this.caseIsBond = true;
      this.reports = true;
    } else if (this.formId === 'dueForm') {
      this.formName = this.data.form;
      this.fileName = this.data.form + '.pdf';
    }

    this.uiInfo.formName = this.form;

    this.userID = localUser.getUserId();
    this.userRole = localUser.getRole();
    this.token = localUser.getToken();
  }

  ngOnInit() {
    this.getCaseData();
    //this.getCaseDocuments();
  }

  getCaseData() {

    this.caseService.getCaseById('', this.case)
      .subscribe(result => {
        this.org = result.ward.organization_id;

        if (result.length === 0) {
          // put error here and close box
          return;
        }

        if (this.temp === this.case) {
          this.caseData = result;
          if (this.formId === 'dueForm') {
            this.caseStatus = 'NEEDS_UPLOAD_FROM_GUARDIAN';
          } else {
            this.caseStatus = this.caseData.summary.status;
          }
        }
        else {
          let dueForms = result.due_forms;

          let useId = this.case;

          if (this.temp !== null) {
            useId = this.temp;
          }

          for (let i = 0; i < dueForms.length; i++) {
            if (useId === dueForms[i].id && this.form === dueForms[i].details.id) {
              this.caseData = dueForms[i];
            }
          }
          if (this.formId === 'dueForm') {
            this.caseStatus = 'NEEDS_UPLOAD_FROM_GUARDIAN';
          } else {
            this.caseStatus = this.caseData.summary.status;
          }
        }

        switch (this.caseStatus) {

          case 'UPLOAD_DENIED_BY_CLERK':
          case 'UPLOAD_DENIED_BY_JUDGE':
          case 'NEEDS_UPLOAD_FROM_PETITIONER':
            this.uiInfo.action = 'notarize';
            break;

          case 'NEEDS_UPLOAD_FROM_JUDGE':
          case 'UPLOAD_JUDGE_SIGNED':
            this.uiInfo.action = 'have judge sign';
            break;
          case 'FILED_FOR_CLERK':
            this.uiInfo.action = 'notarize';
            break;
          case 'BOND_UPLOADED':
            if (this.caseData !== null) {
              this.caseIsBond = this.caseData.summary.is_bond;
            }
            break;
        }
        if (!this.caseIsBond) {
          this.download();
        }
      });
  }

  getCaseDocuments() {
    this.downloadFormLoader = true
    this.preSign
      .getList(this.data.org, this.data.case, false)
      .subscribe(result => {
        result.forEach(item => {
          if (item.file_name == this.fileName) {
            this.downloadPDFLink = item.url;
          }
          this.downloadFormLoader = false
        })
      });
  }
  fileUpload(event) {
    // this makes sure they did not just back out of the file selector.
    if (event.target.files.length === 0) {
      return 0;
    }
    this.loading = true;
    this.form = "GAL-report_signed";
    this.uploadFile(event.target.files[0], '');
  }

  fileUpload2(event) {
    // this makes sure they did not just back out of the file selector.
    if (event.target.files.length === 0) {
      return 0;
    }
    // this.loading = true;
    this.loadingTwo = true;
    this.form = "GAL-fees_signed";
    this.uploadFile(event.target.files[0], '');
  }
  upload(event) {
    this.loading = true;
    // this makes sure they did not just back out of the file selector.
    if (event.target.files.length === 0) {
      return 0;
    }

    let file = event.target.files[0];


    switch (this.caseStatus) {
      case 'UPLOAD_DENIED_BY_CLERK':
      case 'UPLOAD_DENIED_BY_JUDGE':
      case 'NEEDS_UPLOAD_FROM_PETITIONER':
      case 'NEEDS_UPLOAD_FROM_GUARDIAN':
      case 'APPROVED_BY_JUDGE':
      case 'APPROVED_BY_CLERK':
      case 'FILED_FOR_CLERK':
      case 'UPLOAD_DOCUMENT':
      case 'BOND_UPLOADED':
      case 'UPLOAD_JUDGE_SIGNED':
        this.uploadFile(file, '_signed');
        break;

      case 'NEEDS_UPLOAD_FROM_JUDGE':
        this.uploadFile(file, '_decreed');
        break;
    }

  }

  // this actually uploads the file to s3
  uploadFile(file, name) {
    if(file.type == 'application/pdf') {
      let fileName = this.form + name + '.pdf';
      this.preSign.getPresign(this.org, this.case, fileName)
      .subscribe(result => {

        this.preSign.uploadFile(result, file)
          .subscribe(resultt => {
            if (resultt === 200) {
              let data;

              if (this.formId === 'dueForm') {
                this.caseService.putStatusUpdate(this.data.case, this.data.formId, 'SUBMIT')
                  .subscribe(result => {
                    this.thisDialog.close(true);
                    this.loading = false;
                    this.loadingTwo = false;
                  });
                
              } else {
                switch (this.form) {

                  case 'GAL-report_signed':
                    this.upload1 = true;
                    this.checkUploadstatus()
                    this.loading = false;
                    break;

                  case 'GAL-fees_signed':
                    this.upload2 = true;
                    this.checkUploadstatus()
                    this.loading = false;
                    this.loadingTwo = false;
                    break;

                  case 'PC2.6-appointment-of-guardian-ad-litem':
                    data = {
                      status: 'UPLOAD_REPORT_AND_FEES'
                    };
                    this.caseService.putCaseNew(this.org, this.case, data)
                      .subscribe(result => {
                        this.thisDialog.close(true);
                      });
                    break;

                  case 'PC3.3-Inventory':
                    data = {
                      status: 'UPLOADED_INVENTORY'
                    };
                    this.caseService.putCaseNew(this.org, this.case, data)
                      .subscribe(result => {
                        this.thisDialog.close(true);
                      });
                    break;

                  case '2.3_judge':
                    data = {
                      status: 'APPROVED_BY_CLERK'
                    };
                    this.caseService.putCaseNew(this.org, this.case, data)
                      .subscribe(result => {
                        this.thisDialog.close(true);
                      });
                    break;

                  case '2.3':

                    switch (this.caseStatus) {

                      case 'UPLOAD_DENIED_BY_CLERK':
                      case 'UPLOAD_DENIED_BY_JUDGE':
                      case 'NEEDS_UPLOAD_FROM_PETITIONER':
                        data = {
                          status: 'UPLOAD_FILED_FOR_CLERK'
                        };
                        this.caseService.putCaseNew(this.org, this.case, data)
                          .subscribe(result => {
                            this.thisDialog.close(true);
                          });
                        break;

                      case 'NEEDS_UPLOAD_FROM_JUDGE':
                        data = {
                          status: 'FILED_FOR_JUDGE'
                        };
                        this.caseService.putCaseNew(this.org, this.case, data)
                          .subscribe(result => {
                            this.thisDialog.close(true);
                          }, error => {
                            this.loading = false;
                            this.loadingTwo = false;
                            this.error = 'Server Not Responding';
                            this.snackBar.open(this.error, '', {
                              duration: 2000,
                            });
                          });
                        break;

                    }

                    break;

                  case '2.8':

                    switch (this.caseStatus) {

                      case 'UPLOAD_DENIED_BY_CLERK':
                      case 'UPLOAD_DENIED_BY_JUDGE':
                      case 'NEEDS_UPLOAD_FROM_GUARDIAN':
                      case 'FILED_FOR_CLERK':
                        let sendData = {};
                        this.caseService.putTwoEight(this.case, this.data.form_Id, 'UPLOAD_FILED_FOR_CLERK', sendData)
                          .subscribe(result => {
                            this.thisDialog.close(true);
                          });
                        this.thisDialog.close(true)
                        break;
                    }

                    break;

                  case '3.4':

                    switch (this.caseStatus) {

                      case 'UPLOAD_DENIED_BY_CLERK':
                      case 'UPLOAD_DENIED_BY_JUDGE':
                      case 'NEEDS_UPLOAD_FROM_GUARDIAN':
                        data = {
                          status: 'UPLOAD_FILED_FOR_CLERK'
                        };
                        this.caseService.putCaseNew(this.org, this.case, data)
                          .subscribe(result => {
                            this.thisDialog.close(true);
                          });
                        break;

                    }

                    break;

                  case '7.1':

                    switch (this.caseStatus) {

                      case 'UPLOAD_DENIED_BY_CLERK':
                      case 'UPLOAD_DENIED_BY_JUDGE':
                      case 'NEEDS_UPLOAD_FROM_GUARDIAN':
                      case 'FILED_FOR_CLERK':

                        let senddata = {
                          form_id: this.form,
                          petitionData: {},
                          status: 'UPLOAD_FILED_FOR_CLERK'
                        };

                        this.caseService.putDueForm(this.case, this.data.form_Id, 'UPLOAD_FILED_FOR_CLERK', senddata)
                          .subscribe(result => {
                            this.thisDialog.close(true);
                          });

                        break;

                      case 'NEEDS_UPLOAD_FROM_JUDGE':
                        senddata = {
                          form_id: this.form,
                          petitionData: {},
                          status: 'APPROVED_BY_CLERK'
                        };


                        this.caseService.putDueForm(this.org, this.case, this.form, senddata)
                          .subscribe(result => {
                            this.thisDialog.close(true);
                          });
                        break;
                    }
                    break;

                  case '3.5':
                    switch (this.caseStatus) {
                      case 'APPROVED_FOR_JUDGE':
                      case 'APPROVED_FOR_CLERK':

                        // let senddata = {
                        //   form_id: this.form,
                        //   petitionData: {},
                        //   status: 'UPLOAD_FILED_FOR_CLERK'
                        // };

                        // this.caseService.putDueForm(this.case, this.data.form_Id, 'UPLOAD_FILED_FOR_CLERK', senddata)
                        //   .subscribe(result => {
                        //     this.thisDialog.close(true);
                        //   });

                        break;
                    }

                    break;

                  default:
                    this.thisDialog.close(true);
                    break;

                }
              }
            }
          });
      });
    }
    else {
      this.snackBar.open('Please upload only pdf format.', null, {
        extraClasses: ['error-snackbar'],
        duration: 5000
      });
    }
  }

  checkUploadstatus() {
    if (this.upload1 == true && this.upload2 == true) {
      this.loading = true;
      let d = {
        status: 'SET_JUDGEMENT'
      };
      this.caseService.putCaseNew(this.data.org, this.data.case, d)
        .subscribe(result => {
          this.loading = false;
          this.thisDialog.close(true);
        });
    }
  }
  download() {
    this.isError = false;
    switch (this.caseStatus) {
      case 'NEEDS_UPLOAD_FROM_JUDGE':
        this.downloadForm('_signed');
        break;
      default:
        this.downloadForm('');
        break;
    }

  }

  downloadFile(data, fileName) {


    // data = data._body;

    let fileType: string;
    let meme = '';

    let regex = /\.[a-zA-Z0-9]+$/;
    fileType = regex.exec(fileName).toString();

    switch (fileType.toUpperCase()) {
      case '.PDF':
        meme = 'application/pdf';
        break;
      case '.JPG':
        meme = 'image/jpeg';
        break;
    }

    let file = new Blob([data]);

    let link = document.createElement('a');
    let url = URL.createObjectURL(file);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadForm(part) {
    //let fileName = `${this.form}${part}.pdf`;
    this.downloadFormLoader = true
    this.preSign.getList(this.org, this.case, false)
      .subscribe(result => {

        let file = this.getFileFromList(result, this.fileName);
        this.downloadPDFLink = file.url;
        this.downloadFormLoader = false;
      });

  }

  getFileFromList(files, fileName) {
    for (let i = 0; i < files.length; i++) {
      let fName = files[i].file_name;
      if (fName === fileName && files[i].disposition == "attachment") {
        return files[i];
      }
    }
  }



  onNoClick(): void {
    this.thisDialog.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/downloadUpload/downloadUpload.component.ts